import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PageHero = ({ eyebrow, title, subtitle, image, cta }) => (
  <section
    data-testid="page-hero"
    className="relative pt-36 md:pt-44 pb-20 md:pb-28 overflow-hidden bg-forest text-cream"
  >
    <div
      className="absolute inset-0 bg-cover bg-center opacity-40"
      style={{ backgroundImage: `url(${image})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-forest/80 via-forest/60 to-forest" />
    <div className="grain" />
    <div className="container mx-auto px-6 md:px-10 xl:px-16 relative">
      <div className="max-w-4xl">
        {eyebrow && (
          <p className="eyebrow text-saffron" data-testid="page-hero-eyebrow">
            {eyebrow}
          </p>
        )}
        <h1 className="mt-6 font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-8 max-w-2xl text-cream/80 text-lg leading-relaxed">
            {subtitle}
          </p>
        )}
        {cta && (
          <Link to={cta.to} className="btn-accent mt-10" data-testid="page-hero-cta">
            {cta.label} <ArrowRight size={14} />
          </Link>
        )}
      </div>
    </div>
  </section>
);

export default PageHero;
